import toLowerCase from '../toLowerCase';
export default function toKebabCase(string) {
  if (typeof string === 'string') {
    return string.replace(/\s/g, '-').replace(/[A-Z]/g, toLowerCase);
  }
  return string;
}